import { Component, OnInit, ViewChild, Injector } from '@angular/core';
import { UntypedFormGroup, UntypedFormBuilder, FormArray, Validators } from '@angular/forms';
import { MatPaginator } from '@angular/material/paginator';
import { MatSort } from '@angular/material/sort';
import { MatTableDataSource } from '@angular/material/table';
import { Router, ActivatedRoute } from '@angular/router';
import { CommonService } from 'src/app/shared/common.service';
import { Global } from 'src/app/Global';
import saveAs from 'file-saver';
import { HTTPStatus } from 'src/app/Common/app-token-handler';
import { AppErrorHandler } from 'src/app/Common/app-error-handler';
import { ServiceRequestService } from 'src/app/shared/service-request.service';
import { MatDialog, MatDialogRef } from '@angular/material/dialog';
import { SearchViewComponent } from 'src/app/out-of-application/search-view/search-view.component';

@Component({
  selector: 'app-view-service-request',
  templateUrl: './view-service-request.component.html',
  styleUrls: ['./view-service-request.component.scss']
})
export class ViewServiceRequestComponent implements OnInit {
  // version = VERSION;
  pageID: string;
  selectedSR: any;
  // SRNumberList: any;
  // SRNoDetails: any;
  SearchViewDialogRef: MatDialogRef<SearchViewComponent>;
  ServiceRequestForm: UntypedFormGroup;
  IsCloseTapped = false;
  statusList: any;
  isLoadingResults = false;
  searchParameter: any = [];
  array: any;
  lblheader: string = '';
  displayedColumns = ['SRNumber', 'CreatedOn', 'LongDescription', 'Requester', 'OnBehalfOfRequester',
    'ShortDescription', 'RequesterGPN', 'AssignmentGroup', 'TicketStatus', 'AssignedTo'];

  SRDataSource: MatTableDataSource<any[]>;
  @ViewChild(MatPaginator) paginator: MatPaginator;
  @ViewChild(MatSort) sort: MatSort;
  constructor(private _fb: UntypedFormBuilder, private _router: Router, public _global: Global,
    private _activeRoute: ActivatedRoute, public _commonService: CommonService, private error: AppErrorHandler,
    injector: Injector, private status: HTTPStatus, private _serviceRequestService: ServiceRequestService, private _dialog: MatDialog,) { }

  ngOnInit() {
    this.pageID = this._activeRoute.snapshot.paramMap.get('ID');
    //this.paginator.showFirstLastButtons = true;
    //this.paginator.pageSize = this._global.RecordSize;

    this.ServiceRequestForm = this._fb.group({

      Status: [],
      PageNumber: (this._global.pageIndex),
      PageID: (this.pageID),
      IsExport: 0,
      FilterList: this._fb.array([]),
      RecordSize: this._global.RecordSize

    });
    // this.AddSRNumbers(this.pageID)
    //window.console.log(this.pageID);
    this.LoadFilterDetail();
    this.onMonitorlist();

  }

  ngAfterViewInit() {
    if (this.paginator) {
      this.paginator.pageSize = this._global.RecordSize;
      this.paginator.showFirstLastButtons = true;
    }
  }
  // AddSRNumbers(PageIDForSearch: any){
  //   let datalist = [];
  //   let objForSearchData ={
  //     PageID: PageIDForSearch,
  //     FilterList: []
  //    };

  //   this._serviceRequestService.GetAllServiceRequest(objForSearchData).subscribe(data => {

  //     if (data.RequestData != null && data.RequestData.length > 0) {

  //       data.RequestData.forEach(function (value) {

  //       datalist.push({ 'Key': value.Id, 'Value': value.SRNumber });

  //       }); 
  //       this.SRNoDetails = datalist;

  //     }
  //   }, (error) => {
  //     this.status.setHttpStatus(false);
  //     this.error.handleError(error);
  //   }, () => { this.status.setHttpStatus(false); });
  // }
  SearchRecord() {
    this._global.pageIndex = 1;
    this._global.length = 0;
    this._global.totalPage = 0;
    this.searchParameter = this.ServiceRequestForm.controls;
    this.ServiceRequestForm.controls.PageNumber.setValue(this._global.pageIndex);
    this.LoadAllServiceRequestList(this.ServiceRequestForm.value);
  }

  SearchSR() {
    let objForSearchData;
    if (!this.CheckForNullEmptyAndUndefined(this.selectedSR)) {
      objForSearchData = {
        PageID: this.pageID,
        FilterList: [{
          'FilterColumnsID': "15",
          'SearchText': this.selectedSR,
          'FilterColumnsDisplay': "SR Number",
          'FilterColumnsOriginal': "SRNumber",
          'FilterContainValues': "1",
          'FilterContainDisplayText': "Contains",
          'Operators': "AND",
          'DataType': undefined,
          'ParameterName': "SRNumber"
        }]
      };

      this._global.pageIndex = 1;
      this._global.length = 0;
      this._global.totalPage = 0;
      this.ServiceRequestForm.controls.PageNumber.setValue(this._global.pageIndex);
      this.LoadAllServiceRequestList(objForSearchData);
    }
    else {
      objForSearchData = {
        PageID: this.pageID,
        FilterList: [{
          'FilterColumnsID': "",
          'SearchText': "",
          'FilterColumnsDisplay': "",
          'FilterColumnsOriginal': "",
          'FilterContainValues': "",
          'FilterContainDisplayText': "",
          'Operators': "",
          'DataType': undefined,
          'ParameterName': ""

        }]
      };
      this.LoadAllServiceRequestList(objForSearchData);
    }

  }

  convertArrayToObject = (array, key) => {
    const initialValue = {};
    return array.reduce((obj, item) => {
      return {
        ...obj,
        [item[key]]: item,
      };
    }, initialValue);
  };
  CheckForNullEmptyAndUndefined(value: any): boolean {
    if (value != null && value != '' && value != undefined)
      return false
    else
      return true
  }

  // filterSR(filter: any) {
  //   let filtered: any[] = [];
  //   let query = filter.query;
  //   this.SRNumberList = this.SRNoDetails;
  //   if (this.SRNumberList != null ) {
  //     for (let i = 0; i < this.SRNumberList.length; i++) {
  //       let state = this.SRNumberList[i];
  //       if (state.Value.toLowerCase().indexOf(query.toLowerCase()) == 0) {
  //         filtered.push(state);
  //       }
  //     }
  //   }
  //   this.SRNumberList = filtered;
  //  }

  clearAutoComplete(event) {

  }
  LoadAllServiceRequestList(searchParameter) {
    let datalist = [];
    if (!this.IsCloseTapped) {
      this.status.setHttpStatus(true);

    } else {
      this.IsCloseTapped = false;
      //this.status.setHttpStatus(false);
    }


    if (this._global.pageIndex === 0) {
      this._global.pageIndex = 1;
    }
    if (this.searchParameter != undefined) {
      this.searchParameter.PageNumber = this._global.pageIndex;
      this.searchParameter.RecordSize = this._global.RecordSize;
      this.searchParameter = searchParameter;
    }
    this._serviceRequestService.GetAllServiceRequest(searchParameter).subscribe(data => {

      if (data.RequestData != null && data.RequestData.length > 0) {

        this.SRDataSource = new MatTableDataSource(data.RequestData);
        // data.RequestData.forEach(function (value) {

        // datalist.push({ 'Key': value.Id, 'Value': value.SRNumber });

        // }); 
        // this.SRNoDetails = datalist;

        if (this._global.length === 0) {
          this._global.length = data.TotalRecordCount;
          this.SRDataSource.paginator = this.paginator;
          this._global.totalPage = Math.ceil(this._global.length / this.paginator.pageSize);
          this.SRDataSource.sort = this.sort;
        } else {
          this._global.length = data.TotalRecordCount;
          this._global.totalPage = Math.ceil(this._global.length / this.paginator.pageSize);
          this.paginator.pageIndex = this._global.pageIndex - 1;
          this.status.setHttpStatus(false);
        }
      } else {
        this.SRDataSource = new MatTableDataSource(data.RequestData);
        this._global.length = data.TotalRecordCount;
        this.paginator.pageSize = this._global.RecordSize;
        this._global.pageIndex = 0;
        this._global.totalPage = 0;
      }
    }, (error) => {
      this.status.setHttpStatus(false);
      this.error.handleError(error);
    }, () => { this.status.setHttpStatus(false); });
  }
  ShowDetails(row: any) {
    this._router.navigate(['/ServiceRequest', row.RequestEntityId]);
  }
  onPaginateChange(e: any) {
    this._global.RecordSize = (e.pageSize);
    this._global.pageIndex = (e.pageIndex + 1);
    this.LoadAllServiceRequestList(this.searchParameter);
  }

  GoToPage() {
    if (this._global.pageIndex <= 0) { this._global.pageIndex = 1; } else if
      (this._global.pageIndex > this._global.totalPage) {
      this._global.pageIndex = this._global.totalPage;
    }
    this.LoadAllServiceRequestList(this.searchParameter);
  }
  openSearchDialog() {
    this.SearchViewDialogRef = this._dialog.open(SearchViewComponent, {
      height: '300px',
      width: '800px',
      data: { pageid: this.pageID, data: this.searchParameter }
    });

    this.SearchViewDialogRef.afterClosed().subscribe(result => {
      if (result != undefined) {
        this.searchParameter = result;
        this.IsCloseTapped = true;
        this.LoadAllServiceRequestList(this.searchParameter.value);
      }
    })
  }

  LoadFilterDetail() {
    this._serviceRequestService.GetUserWiseFilterDetail(this.ServiceRequestForm.value).subscribe(data => {
      if (data != undefined) {
        this.searchParameter = data;
        this.searchParameter.PageID = this.pageID;
        this.LoadAllServiceRequestList(this.searchParameter);
      }
      else {
        this.SearchRecord();
      }
    }, (error) => {
      this.error.handleError(error);
    }, () => { });
  }

  public handlePage(e: any) {
    this._global.pageIndex = e.pageIndex;
    this._global.RecordSize = e.pageSize;
    this.iterator();
  }

  private iterator() {
    const end = (this._global.pageIndex + 1) * this._global.RecordSize;
    const start = this._global.pageIndex * this._global.RecordSize;
    const part = this.array.slice(start, end);
    this.LoadAllServiceRequestList(this.searchParameter);
  }
  Export() {
    this.ServiceRequestForm.controls.IsExport.setValue(1);
    this._serviceRequestService.ExportData(this.ServiceRequestForm.value).subscribe(x => {
      const blob = new Blob([x], { type: 'application/octet-stream' });
      saveAs(blob, 'ServiceRequest.xls');
    });
  }

  onMonitorlist() {
    if (this.ServiceRequestForm.controls.PageID.value == 2) {
      //document.getElementById("lblheader").innerHTML = "Assigned to me";
      this.lblheader = "Assigned to me";
    }
    else if (this.ServiceRequestForm.controls.PageID.value == 3) {
      //document.getElementById("lblheader").innerHTML = "All Requests";
      this.lblheader = "All Requests";
    }
    else if (this.ServiceRequestForm.controls.PageID.value == 4) {
      //document.getElementById("lblheader").innerHTML = "Assigned";
      this.lblheader = "Assigned";
    }
    else if (this.ServiceRequestForm.controls.PageID.value == 5) {
      //document.getElementById("lblheader").innerHTML = "In Progress";
      this.lblheader = "In Progress";
    }
    else if (this.ServiceRequestForm.controls.PageID.value == 6) {
      //document.getElementById("lblheader").innerHTML = "Awaiting Requestor";
      this.lblheader = "Awaiting Requestor";
    }
    else if (this.ServiceRequestForm.controls.PageID.value == 7) {
      //document.getElementById("lblheader").innerHTML = "Cancelled";
      this.lblheader = "Cancelled";
    }
    else if (this.ServiceRequestForm.controls.PageID.value == 8) {
      //document.getElementById("lblheader").innerHTML = "My Group's Service Request-Unassigned";
      this.lblheader = "My Group's Service Request-Unassigned";
    }
    else if (this.ServiceRequestForm.controls.PageID.value == 9) {
      //document.getElementById("lblheader").innerHTML = "My History";
      this.lblheader = "My History";
    }
  }

}

// export interface SRDetails {
//   SRNumber: string;
// }
